type BrandLogoProps = {
  detail?: string;
};

export function BrandMark({title}: {title?: string}) {
  return (
    <svg
      className="brand-mark"
      viewBox="0 0 32 32"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <path className="brand-mark-body" d="M9 25V7h8c4 0 6 2.2 6 5.5S21 18 17 18H9" />
      <path className="brand-mark-step" d="m17 18 7 7" />
    </svg>
  );
}

export function BrandLogo({detail}: BrandLogoProps) {
  return (
    <div className="logo" aria-label={detail ? `REŽIM, ${detail}` : 'REŽIM'}>
      <span className="logo-tile" aria-hidden="true"><BrandMark /></span>
      <span className="logo-copy">
        <strong>REŽIM</strong>
        {detail && <small>{detail}</small>}
      </span>
    </div>
  );
}
